import { Card, Flex, Grid, Image } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import defaultImage from "../../../../../../assets/images/content/empty_session.webp";
import CaretDown from "../../../../../../assets/images/icons/CaretDown";
import { H6, P1, P2 } from "../../../../../../components/NormalFonts";
import { useGetSkiResort } from "../../../../../../hooks/Resorts/resort.hooks";
import { SearchSessionDetail } from "../../../../../../hooks/Search/data";
import useGetTimezone from "../../../../../../hooks/Timezone/timezone.hooks";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { orderType } from "../../../../../Record/enumerations/orderType";
import { SessionItem } from "../../../SearchResult/components";
import { PaymentItemProps } from "./data";
import styles from "./styles.module.scss";

const PaymentItem: React.FC<PaymentItemProps> = ({ order, nickname }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const { toLocalTimezone, formatDate } = useGetTimezone();
  const screens = useBreakpoint();
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  // const [sessionDetail, setSessionDetail] = useState<SearchSessionDetail[]>([]);

  const { data: resortList } = useGetSkiResort({});

  const renderDate = (sessions: SearchSessionDetail[]) => {
    if (sessions.length <= 0) return;
    if (sessions.length <= 1) {
      return formatDate(toLocalTimezone(sessions[0].date));
    }
    return `${formatDate(
      toLocalTimezone(sessions[0].date)
    )} - ${toLocalTimezone(sessions[sessions.length - 1].date)?.format(
      `MM${t("format.date.month")}DD${t("format.date.date")}`
    )}`;
  };

  const handleOpenDetail = () => {
    setOpenDetail((prev) => !prev);
  };

  // useEffect(() => {
  //   if (order.session_detail) setSessionDetail(order.session_detail);
  //   else setSessionDetail(order?.session_details || []);
  // }, [order]);

  const renderPaymentList = () => {
    if (order.order_type && order.order_type === orderType.REPLENISH_ORDER) {
      return (
        <>
          <Flex
            flex={1}
            gap={4}
            vertical
            align={"flex-start"}
            justify={"flex-start"}
          >
            <P1 color="var(--text-content-1)">
              {`${t("order.fixreason")} : ${order.fix_reason}`}
            </P1>

            <div className={styles.totalAmountWrapper}>
              <P2 color="var(--text-content-3)">{t("search.summary")}</P2>
              <H6 weight="heavy" color="var(--primary)">{`${t(
                `currency.${process.env.REACT_APP_CURRENCY}`
              )}${moneyFormat(order.total_price)}`}</H6>
            </div>
          </Flex>
        </>
      );
    }
    return (
      <>
        {order?.session_details && order?.session_details?.length > 0 ? (
          <Image
            width={84}
            height={84}
            style={{ objectFit: "cover", borderRadius: 8 }}
            preview={false}
            src={
              resortList?.find(
                (resort) => resort.ski_resort_code === order.ski_resort_code
              )?.image_url
            }
            fallback={defaultImage}
          />
        ) : (
          <Image
            width={84}
            height={84}
            style={{ objectFit: "cover", borderRadius: 8 }}
            preview={false}
            src={defaultImage}
          />
        )}
        <Flex
          flex={1}
          gap={4}
          vertical
          align={"flex-start"}
          justify={"flex-start"}
        >
          <Flex
            style={{ width: "100%" }}
            align={"flex-start"}
            justify={"space-between"}
          >
            <P1 weight="medium" color="var(--text-content-1)">
              {order.coach_nickname || nickname
                ? t("normal.coach.nickname", {
                    nickname: nickname || order.coach_nickname,
                  })
                : renderDate(order?.session_details || [])}
            </P1>
            {order?.session_details && order?.session_details?.length > 0 && (
              <CaretDown
                style={{ fontSize: 24, color: "var(--primary-60)" }}
                className={`${styles.arrow} ${openDetail ? styles.open : ""}`}
              />
            )}
          </Flex>
          {(order.coach_nickname || nickname) && (
            <P1 color="var(--text-content-1)">
              {renderDate(order?.session_details || [])}
            </P1>
          )}
          <P1 color="var(--text-content-1)">
            {t(`skiresort.${order.ski_resort_code}`)}
          </P1>
          <P1 color="var(--text-content-1)">
            {t(`checkout.lessons`, {
              skill: t(`normal.skill.${order.skill_code}`),
              count: order?.session_details?.length || 0,
            })}
          </P1>

          <div className={styles.totalAmountWrapper}>
            <P2 color="var(--text-content-3)">{t("search.summary")}</P2>
            <H6 weight="heavy" color="var(--primary)">{`${t(
              `currency.${process.env.REACT_APP_CURRENCY}`
            )}${moneyFormat(order.total_price)}`}</H6>
          </div>
          {/* </div> */}
        </Flex>
      </>
    );
  };

  return (
    <Card style={{ width: "100%" }} size={screens.sm ? "default" : "small"}>
      <div className={styles.container}>
        <div className={styles.orderContainer} onClick={handleOpenDetail}>
          <div className={styles.wrapper}>{renderPaymentList()}</div>
        </div>
        {order.session_details && (
          <div
            className={`${styles.bodyContainer} ${
              openDetail === false ? styles.hidden : ""
            }`}
          >
            {order.session_details.map(
              (session: SearchSessionDetail, index: number) => {
                return (
                  <SessionItem
                    key={`session_${index}`}
                    data={session}
                    nickname={order.coach_nickname || nickname}
                    containerStyle={styles.sessionItemContainer}
                    adults={order.adults}
                    kids={order.kids}
                  />
                );
              }
            )}
          </div>
        )}
      </div>
    </Card>
  );
};

export default PaymentItem;
